import { Z as NoSuchModelError, h as delay } from "./dist-BuEMdYEn.js";
import "msw";
import "msw/node";
import "vitest";
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@ai-sdk/provider-utils/3.0.31/ec2b02e652373362f632ec2c411694343ca859aa4cde84046d95e39a09d5a1ac/node_modules/@ai-sdk/provider-utils/dist/test/index.mjs
function convertArrayToAsyncIterable(values) {
	return { async *[Symbol.asyncIterator]() {
		for (const value of values) yield value;
	} };
}
function convertArrayToReadableStream(values) {
	return new ReadableStream({ start(controller) {
		try {
			for (const value of values) controller.enqueue(value);
		} finally {
			controller.close();
		}
	} });
}
async function convertReadableStreamToArray(stream) {
	const reader = stream.getReader();
	const result = [];
	while (true) {
		const { done, value } = await reader.read();
		if (done) break;
		result.push(value);
	}
	return result;
}
function mockId({ prefix = "id" } = {}) {
	let counter = 0;
	return () => `${prefix}-${counter++}`;
}
//#endregion
//#region ../../../../../../setup-pnpm/node_modules/.bin/store/v11/links/@/ai/5.0.226/fac8217dc8d34e85b5f38a8cc71c59a1b2ae6d9f27e0dd1e2738a30e54e8ae3c/node_modules/ai/dist/test/index.mjs
function simulateReadableStream({ chunks, initialDelayInMs = 0, chunkDelayInMs = 0, _internal }) {
	const delay$1 = _internal?.delay ?? delay;
	let index = 0;
	return new ReadableStream({ async pull(controller) {
		if (index < chunks.length) {
			await delay$1(index === 0 ? initialDelayInMs : chunkDelayInMs);
			controller.enqueue(chunks[index++]);
		} else controller.close();
	} });
}
function notImplemented() {
	throw new Error("Not implemented");
}
var MockEmbeddingModelV2 = class {
	constructor({ provider = "mock-provider", modelId = "mock-model-id", maxEmbeddingsPerCall = 1, supportsParallelCalls = false, doEmbed = notImplemented } = {}) {
		this.specificationVersion = "v2";
		this.provider = provider;
		this.modelId = modelId;
		this.maxEmbeddingsPerCall = maxEmbeddingsPerCall ?? void 0;
		this.supportsParallelCalls = supportsParallelCalls;
		this.doEmbed = doEmbed;
	}
};
var MockImageModelV2 = class {
	constructor({ provider = "mock-provider", modelId = "mock-model-id", maxImagesPerCall = 1, doGenerate = notImplemented } = {}) {
		this.specificationVersion = "v2";
		this.provider = provider;
		this.modelId = modelId;
		this.maxImagesPerCall = maxImagesPerCall;
		this.doGenerate = doGenerate;
	}
};
var MockLanguageModelV2 = class {
	constructor({ provider = "mock-provider", modelId = "mock-model-id", supportedUrls = {}, doGenerate = notImplemented, doStream = notImplemented } = {}) {
		this.specificationVersion = "v2";
		this.doGenerateCalls = [];
		this.doStreamCalls = [];
		this.provider = provider;
		this.modelId = modelId;
		this.doGenerate = async (options) => {
			this.doGenerateCalls.push(options);
			if (typeof doGenerate === "function") return doGenerate(options);
			else if (Array.isArray(doGenerate)) return doGenerate[this.doGenerateCalls.length];
			else return doGenerate;
		};
		this.doStream = async (options) => {
			this.doStreamCalls.push(options);
			if (typeof doStream === "function") return doStream(options);
			else if (Array.isArray(doStream)) return doStream[this.doStreamCalls.length];
			else return doStream;
		};
		this._supportedUrls = typeof supportedUrls === "function" ? supportedUrls : async () => supportedUrls;
	}
	get supportedUrls() {
		return this._supportedUrls();
	}
};
var MockProviderV2 = class {
	constructor({ languageModels, embeddingModels, imageModels, transcriptionModels, speechModels } = {}) {
		this.languageModel = (modelId) => {
			if (!languageModels?.[modelId]) throw new NoSuchModelError({
				modelId,
				modelType: "languageModel"
			});
			return languageModels[modelId];
		};
		this.textEmbeddingModel = (modelId) => {
			if (!embeddingModels?.[modelId]) throw new NoSuchModelError({
				modelId,
				modelType: "textEmbeddingModel"
			});
			return embeddingModels[modelId];
		};
		this.imageModel = (modelId) => {
			if (!imageModels?.[modelId]) throw new NoSuchModelError({
				modelId,
				modelType: "imageModel"
			});
			return imageModels[modelId];
		};
		this.transcriptionModel = (modelId) => {
			if (!transcriptionModels?.[modelId]) throw new NoSuchModelError({
				modelId,
				modelType: "transcriptionModel"
			});
			return transcriptionModels[modelId];
		};
		this.speechModel = (modelId) => {
			if (!speechModels?.[modelId]) throw new NoSuchModelError({
				modelId,
				modelType: "speechModel"
			});
			return speechModels[modelId];
		};
	}
};
var MockSpeechModelV2 = class {
	constructor({ provider = "mock-provider", modelId = "mock-model-id", doGenerate = notImplemented } = {}) {
		this.specificationVersion = "v2";
		this.provider = provider;
		this.modelId = modelId;
		this.doGenerate = doGenerate;
	}
};
var MockTranscriptionModelV2 = class {
	constructor({ provider = "mock-provider", modelId = "mock-model-id", doGenerate = notImplemented } = {}) {
		this.specificationVersion = "v2";
		this.provider = provider;
		this.modelId = modelId;
		this.doGenerate = doGenerate;
	}
};
function mockValues(...values) {
	let counter = 0;
	return () => values[counter++] ?? values[values.length - 1];
}
var simulateReadableStream2 = simulateReadableStream;
//#endregion
export { MockEmbeddingModelV2, MockImageModelV2, MockLanguageModelV2, MockProviderV2, MockSpeechModelV2, MockTranscriptionModelV2, convertArrayToAsyncIterable, convertArrayToReadableStream, convertReadableStreamToArray, mockId, mockValues, simulateReadableStream2 as simulateReadableStream };

//# sourceMappingURL=test.js.map